export default class OddType {
    id: number;
    // egalitate, victoria primului jucător, etc.
    description: string;
    // symbol is X, 1, 2
    symbol: string;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/struct/OddType.ts